/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Provider-specific configuration that extends the standard OAuth flow.
 * @export
 * @interface ProviderAppMetadata
 */
export interface ProviderAppMetadata {
    /**
     * Additional query parameters to include in the OAuth authorization URL (e.g., optional_scope for HubSpot).
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ProviderAppMetadata
     */
    authQueryParams?: { [key: string]: Array<string>; };
    /**
     * Provider-specific string values keyed by names (e.g., packageInstallURL for Salesforce, gcpProjectId and gcpPubSubTopicName for Gmail).
     * @type {{ [key: string]: string; }}
     * @memberof ProviderAppMetadata
     */
    providerParams?: { [key: string]: string; };
}

/**
 * Check if a given object implements the ProviderAppMetadata interface.
 */
export function instanceOfProviderAppMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProviderAppMetadataFromJSON(json: any): ProviderAppMetadata {
    return ProviderAppMetadataFromJSONTyped(json, false);
}

export function ProviderAppMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderAppMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authQueryParams': !exists(json, 'authQueryParams') ? undefined : json['authQueryParams'],
        'providerParams': !exists(json, 'providerParams') ? undefined : json['providerParams'],
    };
}

export function ProviderAppMetadataToJSON(value?: ProviderAppMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authQueryParams': value.authQueryParams,
        'providerParams': value.providerParams,
    };
}

